import { DocumentStatusBadge } from '#/modules/commonComponents/badge';
import { formatDateOrDash } from '#/utils/date';

function formatWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '-';
  }
  return [warehouse.code, warehouse.name].filter(Boolean).join(' ') || '-';
}

/** Block A：僅狀態 */
export const stockReturnSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <DocumentStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

/** Block C+：其餘欄位 */
export const stockReturnSideMsgDetailBlock = {
  fields: [
    { label: '退料單號', value: 'returnNo' },
    {
      label: '退料日',
      value: (row) => formatDateOrDash(row?.returnDate),
    },
    {
      key: 'sourceWarehouse',
      label: '來源倉',
      value: (row) => formatWarehouseLabel(row?.sourceWarehouse),
    },
    {
      key: 'targetWarehouse',
      label: '目的倉',
      value: (row) => formatWarehouseLabel(row?.targetWarehouse),
    },
    { label: '退料原因', value: 'issueReason' },
    { label: '項目數', value: 'lineCount' },
    { label: '備註', value: 'remark' },
  ],
};

export const stockReturnSideMsgBlocks = [
  stockReturnSideMsgStatusBlock,
  stockReturnSideMsgDetailBlock,
];
